import { DairyYieldScanSummary } from './dairy-yield-scan.models';

const answerKey = (value: boolean | null | undefined): string => {
  if (value === true) {
    return 'dairyYieldScan.customer.yes';
  }

  if (value === false) {
    return 'dairyYieldScan.customer.no';
  }

  return 'dairyYieldScan.customer.unknown';
};

export const dairyYieldScanCustomerDisplay = (summary: DairyYieldScanSummary) => ({
  statusKey: answerKey(summary.isExistingAgrifirmCustomer),
  feedKey:
    summary.isExistingAgrifirmCustomer === false
      ? 'dairyYieldScan.customer.notApplicable'
      : answerKey(summary.buysAgrifirmCompoundFeed),
  number: summary.customerNumber ?? null,
});
